export enum TemplatesSections {
  surveys = "surveys",
  performanceReviews = "performance-reviews",
}
